import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Login } from 'containers';
import React, { lazy, Suspense, useState } from 'react';
import Storage from 'lib/storage';
import Splash from 'containers/splash/Splash';

const Main = lazy(() => import('layouts/MainContainer'));

function Container() {
  const [loggedIn, setLogin] = useState(Storage.isLoggedIn());

  return (
    <Router>
      <Suspense fallback={<Splash />}>
        {loggedIn ? (
          <Main />
        ) : (
          <Route path="*">
            <Login onLogin={() => setLogin(true)} />
          </Route>
        )}
      </Suspense>
    </Router>
  );
}

export default Container;
